import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { SpotEService } from 'app/providers/semantria-api/spote.service';
import { CollectionService } from 'app/providers/storage-api/collection.service';
import { AlertService } from 'app/services/alert.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ProjectCollection } from '../../models/project-collection.model';

@EnableClassTelemetry()
@Component({
  selector: 'app-collection-scene-select-dialog',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './collection-scene-select-dialog.component.html',
  styleUrls: ['./collection-scene-select-dialog.component.scss'],
})
export class CollectionSceneSelectDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() data: { collection: ProjectCollection };

  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();

  availableScenes: DropdownObject[] = [];
  selectedSceneId = 'null';

  constructor(
    private spotEService: SpotEService,
    private collectionService: CollectionService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    if (this.data.collection.data.summarySceneId) {
      this.selectedSceneId = this.data.collection.data.summarySceneId;
    }

    this.spotEService.listScenes({ type: 'DOCUMENT_SUMMARY' }).then((res) => {
      this.availableScenes = [
        {
          id: 'null',
          title: translate('collection-scene-select.no-smart-summary'),
        },
      ];

      this.availableScenes.push(
        ...res.data.map((scene) => ({
          id: scene.scene_id,
          title: scene.name,
        }))
      );
    });
  }

  onCancel() {
    this.modalClosed.emit(null);
  }

  onSave() {
    const collection = { ...this.data.collection.data };

    collection.summarySceneId = null;
    if ('null' !== this.selectedSceneId) {
      collection.summarySceneId = this.selectedSceneId;
    }

    this.collectionService
      .updateCollection(collection)
      .then(() => {
        this.alertService.showToast(
          translate('collection-scene-select.scene-set-success', {
            scene: this.availableScenes.find((data) => data.id === this.selectedSceneId).title,
            collection: collection.displayName,
          })
        );

        const data = {
          summarySceneId: this.selectedSceneId,
        };

        this.modalClosed.emit(data);
      })
      .catch((err) => {
        this.alertService.showToast(
          translate('collection-scene-select.scene-set-failed', {
            collection: collection.displayName,
          }),
          err
        );
      });
  }
}
